export class RandomService {
  generateString = () => {
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
  }
}
